module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/always.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Always takes a given value and returns a function that will return that value when invoked.
 *
 * @example
 * import always from '@carvana/futilities/always';
 * const fn = always('blue')
 * fn()
 * // () => 'blue'
 *
 */
function always(val) {
  return function () {
    return val;
  };
}

/* harmony default export */ __webpack_exports__["default"] = (always);

/***/ }),

/***/ "./src/alwaysFalse.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A function that always returns the Boolean value of `false`
 */
function alwaysFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (alwaysFalse);

/***/ }),

/***/ "./src/alwaysNull.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A function that always returns the value of `null`
 */
function alwaysNull() {
  return null;
}

/* harmony default export */ __webpack_exports__["default"] = (alwaysNull);

/***/ }),

/***/ "./src/alwaysNumber.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Attempts to convert a given value to a Number and returns zero if that attempt produced `NaN`.
 *
 * @example
 * import alwaysNumber from '@carvana/futilities/alwaysNumber';
 * alwaysNumber('300.17')
 * // () => 300.17
 * alwaysNumber('abc')
 * // () => 0
 * alwaysNumber()
 * // () => 0
 */
function alwaysNumber(value) {
  return Number.isNaN(+value) ? 0 : +value;
}

/* harmony default export */ __webpack_exports__["default"] = (alwaysNumber);

/***/ }),

/***/ "./src/alwaysTrue.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A function that always returns the Boolean value of `true`
 *
 * @kind function
 * @name alwaysTrue
 * @sig * -> Boolean
 * @returns {Boolean} A value of `true`
 */
function alwaysTrue() {
  return true;
}

/* harmony default export */ __webpack_exports__["default"] = (alwaysTrue);

/***/ }),

/***/ "./src/calculateClientSideCorrelationContext.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A function that returns a comma separated string with optional values of userId and browserCookieId. It's used for
 * the header Correlation-Context value
 */
var calculateClientSideCorrelationContext = function calculateClientSideCorrelationContext(userId, browserCookieId) {
  var correlationContext = browserCookieId ? "browserCookieId=" + browserCookieId : '';

  if (userId) {
    correlationContext = correlationContext ? correlationContext + ",userId=" + userId : "userId=" + userId;
  }

  return correlationContext;
};

/* harmony default export */ __webpack_exports__["default"] = (calculateClientSideCorrelationContext);

/***/ }),

/***/ "./src/createId.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Generates an alphanumeric string of a specified character length (defaults to 16 characters).
 *
 * @example
 * import createId from '@carvana/futilities/createId';
 * createId()
 * // () => '23b0sh3a2bhbqqng'
 * createId(3)
 * // () => '3by'
 */
function createId(len, charSet) {
  if (len === void 0) {
    len = 16;
  }

  if (charSet === void 0) {
    charSet = 'abcdefghijklmnopqrstuvwxyz0123456789';
  }

  var text = '';
  var count = len;
  var charSetLength = charSet.length;

  while (count--) {
    text += charSet.charAt(Math.floor(Math.random() * charSetLength));
  }

  return text;
}

/* harmony default export */ __webpack_exports__["default"] = (createId);

/***/ }),

/***/ "./src/crypto.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeString", function() { return decodeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeString", function() { return encodeString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeAndParse", function() { return decodeAndParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeAndStringify", function() { return encodeAndStringify; });
/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/isServerSideRendering.ts");
/* eslint-disable consistent-return */


var stripEquals = function stripEquals(val) {
  return (val || '').replace(/%3D/g, '');
};
/**
 * Creates a base64-encoded string (ASCII) after converting every character in
 * the provided string into a byte of binary data.
 *
 * @example
 * import { encodeString } from '@carvana/futilities/crypto';
 * encodeString('carvana')
 * // () => 'Y2FydmFuYQ=='
 * encodeString('{lorem: \'ipsum\'}')
 * // () => 'e2xvcmVtOiAnaXBzdW0nfQ=='
 * encodeString()
 * // () => undefined
 *
 * @kind function
 * @name decodeAndParse
 * @sig String -> String
 * @param {String} val A raw string to convert to base64
 * @returns {String} A base64-encoded string derived from the original string value
 */


function encodeString(val) {
  try {
    if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return;
    return window.btoa(val);
  } catch (err) {// String is probably not in a format that btoa() can encode it
  }
}
/**
 * Decodes a base64-encoded string into the original string (before it was encoded).
 *
 * @example
 * import { decodeString } from '@carvana/futilities/crypto';
 * decodeString('Y2FydmFuYQ==')
 * // "carvana"
 * decodeString('e2xvcmVtOiAnaXBzdW0nfQ==')
 * // "{lorem: 'ipsum'}"
 * decodeString()
 * // undefined
 *
 * @func
 * @sig String -> String
 * @param {String} val A base64-encoded string to decode
 * @returns {String} A string value that was decoded from a given base64-encoded string
 */


function decodeString(val) {
  try {
    if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return;
    return window.atob(stripEquals(val));
  } catch (err) {// String is probably not in a format that atob() can decode it
  }
}
/**
 * Converts JSON to a string _prior_ to creating a base64-encoded from it.
 * Non JSON values are still base64-encoded.
 *
 * @example
 * import { encodeAndStringify } from '@carvana/futilities/crypto';
 * encodeAndStringify('carvana')
 * // "Y2FydmFuYQ=="
 * encodeAndStringify({lorem: 'ipsum'})
 * // "e2xvcmVtOiAnaXBzdW0nfQ=="
 * encodeAndStringify()
 * // undefined
 *
 * @func
 * @sig String|{k: v} -> String
 * @param {String|Object|Array} val A value which may be an Object, Array, or String
 * @returns {String} A base64-encoded string derived from the original string value
 */


function encodeAndStringify(val) {
  return val ? encodeString(JSON.stringify(val)) : '';
}
/**
 * Parses JSON (if necessary) _after_ decoding a base64-encoded string.
 * Non JSON values are returned as-is (after they've been decoded).
 *
 * @example
 * import { decodeAndParse } from '@carvana/futilities/crypto';
 * decodeAndParse('Y2FydmFuYQ==')
 * // "carvana"
 * decodeAndParse('e2xvcmVtOiAnaXBzdW0nfQ==')
 * // {lorem: 'ipsum'}
 * decodeAndParse()
 * // undefined
 *
 * @func
 * @sig String -> String|{k: v}
 * @param {String} val A base64-encoded string to decode
 * @returns {String|Object|Array} A string value that was decoded from a given base64-encoded string
 * and (if necessary) run through `JSON.parse()`
 */


function decodeAndParse(val) {
  return val ? JSON.parse(decodeString(val)) : {};
}



/***/ }),

/***/ "./src/formatCurrency.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _roundNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/roundNumber.ts");

/**
 * Formats a given number as U.S. currency (dollars)
 *
 * @example
 * import formatCurrency from '@carvana/futilities/formatCurrency';
 * formatCurrency(20)
 * // () => '$20'
 * formatCurrency(19.30)
 * // () => '$19.30'
 *
 * @kind function
 * @name formatCurrency
 * @sig Number -> String
 * @param {Number} value The numeric value to be converted to currency
 * @returns {String} The original number formatted as U.S. currency
 */

function formatCurrency(value) {
  return "" + Object(_roundNumber__WEBPACK_IMPORTED_MODULE_0__["default"])(value, 2);
}

/* harmony default export */ __webpack_exports__["default"] = (formatCurrency);

/***/ }),

/***/ "./src/formatNumber.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _alwaysNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/alwaysNumber.ts");

/**
 * Formats a numeric value as a comma-separated string (every 3 digits).
 *
 * @example
 * import formatNumber from '@carvana/futilities/formatNumber';
 * formatNumber(100000)
 * // () => '1,000,000'
 * formatNumber(100)
 * // () => '100'
 *
 * @kind function
 * @name formatNumber
 * @sig Number -> String
 * @param {Number} value The numeric value to be formatted
 * @returns {String} The original value formatted as a comma-separated string
 */

function formatNumber(num) {
  return String(Object(_alwaysNumber__WEBPACK_IMPORTED_MODULE_0__["default"])(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* harmony default export */ __webpack_exports__["default"] = (formatNumber);

/***/ }),

/***/ "./src/getAccessToken.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/index.ts");

/**
 * Grabs access token from carvana cookie
 *
 * @example
 * import getCookie from '@carvana/futilities/getCookie';
 * getAccessToken()
 * () => 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyIsImtpZCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyJ9.eyJpc3MiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkiLCJhdWQiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkvcmVzb3VyY2VzIiwiZXhwIjoxNTYzNDAxMDk4LCJuYmYiOjE1NjM0MDA3OTgsImNsaWVudF9pZCI6IkNhcnZhbmFDb21EZWxlZ2F0aW9uIiwic2NvcGUiOiJjYXJ2YW5hX2NvbSIsInN1YiI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImF1dGhfdGltZSI6MTU2MzQwMDc5OCwiaWRwIjoiaWRzcnYiLCJyb2xlIjpbImFkbWluIiwiY3VzdG9tZXJzZXJ2aWNlIiwiZGV2ZWxvcGVyIiwiRW5naW5lZXJpbmciLCJpbXBlcnNvbmF0ZSIsIkltcGVyc29uYXRlVXNlciIsIlByZS1GaSIsIlFDVGVjaCIsIlFDVGVjaExlYWQiLCJ1c2VyIl0sIm5hbWUiOiJ0eWxlci5jaGVzd2lja0BjYXJ2YW5hLmNvbSIsImlzX2ltcGVyc29uYXRpbmciOiJGYWxzZSIsImltcGVyc29uYXRpbmdfdXNlciI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImFtciI6WyJ0cnVzdGVkIl19.A6KJ1lhhgSvdomZ81-QUBJTpzF2JAkBgg49eoYjPj49Pa3dUWbUruQBz8TMNLOHTJCzyfEbK8AUF91bOOuNrGZqZXosbmiRRLF_iootilMLnAQ_28Na9UPDgy0-sOz0ujAGV3XU4LkYiaM2Q4fH1QJ55qX6QuAUJklErt2576c3zrwt91QdP3xw-gWyUx4Bo30ba0iVByZQgeaf4bnrXVMWN9smdQV0jMNAJ1tGW85TEWA_aU7E--nC5E0e57n3iK-jPwqInJLCWcR4KgeNjWuyp3gWONMGjd1E6eK2EYrInY976d1Sp18lS7gl_JAj0bdkD0r5MqfWkE34EYfhyhQ'
 */

var getAccessToken = function getAccessToken() {
  var cookie = Object(_index__WEBPACK_IMPORTED_MODULE_0__["getCookie"])('CVAccessToken');

  try {
    return cookie.access_token;
  } catch (err) {
    return null;
  }
};

/* harmony default export */ __webpack_exports__["default"] = (getAccessToken);

/***/ }),

/***/ "./src/getCookie.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _safeParse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/safeParse.ts");
/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/isServerSideRendering.ts");
/* eslint-disable consistent-return */


/**
 * Retrieves and parses a given cookie value by name. Encoded URI component
 * strings will be decoded and JSON strings will be parsed into actual JSON,
 * and numeric strings will be parsed as Numbers.
 */

function getCookie(key) {
  if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_1__["default"])()) return;
  var cookie = document.cookie.split('; ').map(function (c) {
    return c.split('=');
  }).find(function (c) {
    return c[0] === key;
  });
  if (!cookie || cookie[1] === undefined) return undefined;
  var val = decodeURIComponent(cookie[1]);

  if (!Number.isNaN(Number(val))) {
    return Number(val);
  }

  return Object(_safeParse__WEBPACK_IMPORTED_MODULE_0__["default"])(val) || val;
}

/* harmony default export */ __webpack_exports__["default"] = (getCookie);

/***/ }),

/***/ "./src/getScrollBarSize.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return scrollbarSize; });
/**
 * Gets the size of the scroll bar to be used to correct elements
 * that cause the scrollbar to appear and cause padding issues
 */
var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (typeof window !== 'undefined' && window.document && window.document.createElement) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),

/***/ "./src/hasOwn.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Checks if a given prop exists on an Object
 */
function hasOwn(obj, key) {
  return {}.hasOwnProperty.call(obj || {}, key);
}

/* harmony default export */ __webpack_exports__["default"] = (hasOwn);

/***/ }),

/***/ "./src/hexToRGB.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var getValuePair = function getValuePair(value, start, end) {
  return parseInt(value.substring(start, end), 16);
};

var HexToRgb = function HexToRgb(hex) {
  var rgbValues = hex.replace('#', '');
  var red = getValuePair(rgbValues, 0, 2);
  var green = getValuePair(rgbValues, 2, 4);
  var blue = getValuePair(rgbValues, 4, 6);
  var rgbValue = red + ", " + green + ", " + blue;
  return rgbValue;
};

/* harmony default export */ __webpack_exports__["default"] = (HexToRgb);

/***/ }),

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/crypto.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "decodeString", function() { return _crypto__WEBPACK_IMPORTED_MODULE_0__["decodeString"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "encodeString", function() { return _crypto__WEBPACK_IMPORTED_MODULE_0__["encodeString"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "decodeAndParse", function() { return _crypto__WEBPACK_IMPORTED_MODULE_0__["decodeAndParse"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "encodeAndStringify", function() { return _crypto__WEBPACK_IMPORTED_MODULE_0__["encodeAndStringify"]; });

/* harmony import */ var _localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/localStorage.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loadItemFromLocalStorage", function() { return _localStorage__WEBPACK_IMPORTED_MODULE_1__["loadItemFromLocalStorage"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "saveItemToLocalStorage", function() { return _localStorage__WEBPACK_IMPORTED_MODULE_1__["saveItemToLocalStorage"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "deleteItemFromLocalStorage", function() { return _localStorage__WEBPACK_IMPORTED_MODULE_1__["deleteItemFromLocalStorage"]; });

/* harmony import */ var _userLocation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/userLocation.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fromCookies", function() { return _userLocation__WEBPACK_IMPORTED_MODULE_2__["fromCookies"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "saveLocationToCookies", function() { return _userLocation__WEBPACK_IMPORTED_MODULE_2__["saveLocationToCookies"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doesUserLocationMatchCookies", function() { return _userLocation__WEBPACK_IMPORTED_MODULE_2__["doesUserLocationMatchCookies"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "makeUserLocation", function() { return _userLocation__WEBPACK_IMPORTED_MODULE_2__["makeUserLocation"]; });

/* harmony import */ var _createId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/createId.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createId", function() { return _createId__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _roundNumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/roundNumber.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "roundNumber", function() { return _roundNumber__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _formatNumber__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/formatNumber.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatNumber", function() { return _formatNumber__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _formatCurrency__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/formatCurrency.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "formatCurrency", function() { return _formatCurrency__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _hasOwn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/hasOwn.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "has", function() { return _hasOwn__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hasOwn", function() { return _hasOwn__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _isNil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/isNil.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return _isNil__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _safeParse__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/safeParse.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "safeParse", function() { return _safeParse__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _always__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/always.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "always", function() { return _always__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _alwaysFalse__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/alwaysFalse.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _alwaysFalse__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "alwaysFalse", function() { return _alwaysFalse__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _alwaysTrue__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/alwaysTrue.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _alwaysTrue__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "alwaysTrue", function() { return _alwaysTrue__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _alwaysNull__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/alwaysNull.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "alwaysNull", function() { return _alwaysNull__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _alwaysNumber__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/alwaysNumber.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "alwaysNumber", function() { return _alwaysNumber__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _setCookie__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./src/setCookie.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setCookie", function() { return _setCookie__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _getAccessToken__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./src/getAccessToken.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getAccessToken", function() { return _getAccessToken__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _getCookie__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("./src/getCookie.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getCookie", function() { return _getCookie__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _scrollWindowToTop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("./src/scrollWindowToTop.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "scrollToTop", function() { return _scrollWindowToTop__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("./src/isServerSideRendering.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "isServerSideRendering", function() { return _isServerSideRendering__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _getScrollBarSize__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("./src/getScrollBarSize.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getScrollBarSize", function() { return _getScrollBarSize__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _hexToRGB__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("./src/hexToRGB.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hexToRGB", function() { return _hexToRGB__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _usaStates__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("./src/usaStates.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "usaStates", function() { return _usaStates__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _pathOr__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("./src/pathOr.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pathOr", function() { return _pathOr__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _parseJwt__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("./src/parseJwt.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "parseJwt", function() { return _parseJwt__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _calculateClientSideCorrelationContext__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("./src/calculateClientSideCorrelationContext.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "calculateClientSideCorrelationContext", function() { return _calculateClientSideCorrelationContext__WEBPACK_IMPORTED_MODULE_25__["default"]; });































/***/ }),

/***/ "./src/isNil.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Checks to see if a given value is `null` or `undefined`
 *
 * @example
 * import isNil from '@carvana/futilities/isNil';
 * isNil(null)
 * // () => true
 * isNil()
 * // () => true
 * isNil('undefined')
 * // () => false
 * isNil(999)
 * // () => false
 */
function isNil(val) {
  return val == null;
}

/* harmony default export */ __webpack_exports__["default"] = (isNil);

/***/ }),

/***/ "./src/isServerSideRendering.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * Checks if browser globals (like `window`) exist in the current environment.
 * This determines whether or not the application is being run on the client or
 * the server.
 */
function isServerSideRendering() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
}

/* harmony default export */ __webpack_exports__["default"] = (isServerSideRendering);

/***/ }),

/***/ "./src/localStorage.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadItemFromLocalStorage", function() { return loadItemFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveItemToLocalStorage", function() { return saveItemToLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteItemFromLocalStorage", function() { return deleteItemFromLocalStorage; });
/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/isServerSideRendering.ts");

/**
 * Attempts to retrieve a value by name from `window.localStorage`.
 * Is safe (but ineffectual) to run on the server.
 *
 * @example
 * import { loadItemFromLocalStorage } from '@carvana/futilities/localStorage';
 * loadItemFromLocalStorage('token')
 * // () => 'e2xvcmVtOiAnaXBzdW0nfQ=='
 *
 * @kind function
 * @name loadItemFromLocalStorage
 * @sig String -> *
 * @param {String} name The name of a (possible) value in localStorage
 * @returns {*} Either the value pulled from localStorage or `undefined`
 */

function loadItemFromLocalStorage(name) {
  try {
    if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return undefined;
    var serialziedState = window.localStorage.getItem(name);
    return serialziedState ? JSON.parse(serialziedState) : undefined;
  } catch (err) {
    return undefined;
  }
}
/**
 * Commits a given value to `window.localStorage` with the specified key name.
 *
 * @example
 * import { saveItemToLocalStorage } from '@carvana/futilities/localStorage';
 * saveItemToLocalStorage('token', 'e2xvcmVtOiAnaXBzdW0nfQ==')
 * // () => true
 *
 * @kind function
 * @name saveItemToLocalStorage
 * @sig String -> * -> Boolean
 * @param {String} name The key name to give to the value in localStorage
 * @param {*} val A value to commit to localStorage
 * @returns {Boolean} Whether or not the provided value was successfully committed to localStorage
 */

function saveItemToLocalStorage(name, val) {
  try {
    if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return false;
    window.localStorage.setItem(name, JSON.stringify(val));
    return true;
  } catch (err) {
    // ignoring write errors for the time being
    return false;
  }
}
/**
 * Deletes a given value from `window.localStorage` with the specified key name.
 *
 * @example
 * import { deleteItemFromLocalStorage } from '@carvana/futilities/localStorage';
 * deleteItemFromLocalStorage('token')
 * // () => true
 *
 * @kind function
 * @name deleteItemFromLocalStorage
 * @sig String -> * -> Boolean
 * @param {String} name The key name in localStorage
 * @returns {Boolean} Whether or not the provided value was successfully deleted from localStorage
 */

function deleteItemFromLocalStorage(name) {
  try {
    if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return false;
    window.localStorage.removeItem(name);
    return true;
  } catch (err) {
    return false;
  }
}

/***/ }),

/***/ "./src/parseJwt.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/index.ts");

/**
 * Decrypts a JWT string
 *
 * @example
 * import parseJwt from '@carvana/futilities/parseJwt';
 * parseJwt("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyIsImtpZCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyJ9.eyJpc3MiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkiLCJhdWQiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkvcmVzb3VyY2VzIiwiZXhwIjoxNTYzNDAxMDk4LCJuYmYiOjE1NjM0MDA3OTgsImNsaWVudF9pZCI6IkNhcnZhbmFDb21EZWxlZ2F0aW9uIiwic2NvcGUiOiJjYXJ2YW5hX2NvbSIsInN1YiI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImF1dGhfdGltZSI6MTU2MzQwMDc5OCwiaWRwIjoiaWRzcnYiLCJyb2xlIjpbImFkbWluIiwiY3VzdG9tZXJzZXJ2aWNlIiwiZGV2ZWxvcGVyIiwiRW5naW5lZXJpbmciLCJpbXBlcnNvbmF0ZSIsIkltcGVyc29uYXRlVXNlciIsIlByZS1GaSIsIlFDVGVjaCIsIlFDVGVjaExlYWQiLCJ1c2VyIl0sIm5hbWUiOiJ0eWxlci5jaGVzd2lja0BjYXJ2YW5hLmNvbSIsImlzX2ltcGVyc29uYXRpbmciOiJGYWxzZSIsImltcGVyc29uYXRpbmdfdXNlciI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImFtciI6WyJ0cnVzdGVkIl19.A6KJ1lhhgSvdomZ81-QUBJTpzF2JAkBgg49eoYjPj49Pa3dUWbUruQBz8TMNLOHTJCzyfEbK8AUF91bOOuNrGZqZXosbmiRRLF_iootilMLnAQ_28Na9UPDgy0-sOz0ujAGV3XU4LkYiaM2Q4fH1QJ55qX6QuAUJklErt2576c3zrwt91QdP3xw-gWyUx4Bo30ba0iVByZQgeaf4bnrXVMWN9smdQV0jMNAJ1tGW85TEWA_aU7E--nC5E0e57n3iK-jPwqInJLCWcR4KgeNjWuyp3gWONMGjd1E6eK2EYrInY976d1Sp18lS7gl_JAj0bdkD0r5MqfWkE34EYfhyhQ")
 * () => {
 * amr: ["trusted"]
 * aud: "https://carvana-auth-dev.azurewebsites.net/identity/resources"
 * auth_time: 1563400798
 * client_id: "CarvanaComDelegation"
 * exp: 1563401098
 * idp: "idsrv"
 * impersonating_user: "9ec19443-246a-418e-aaa3-2e1542066567"
 * is_impersonating: "False"
 * iss: "https://carvana-auth-dev.azurewebsites.net/identity"
 * name: "tyler.cheswick@carvana.com"
 * nbf: 1563400798
 * role: (10) ["admin", "customerservice", "developer", "Engineering", "impersonate", "ImpersonateUser", "Pre-Fi", "QCTech", "QCTechLead", "user"]
 * scope: "carvana_com"
 * sub: "9ec19443-246a-418e-aaa3-2e1542066567"
 * }
 *
 * Reformatted from https://stackoverflow.com/a/38552302
 */

var parseJwt = function parseJwt(token) {
  try {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return Object(_index__WEBPACK_IMPORTED_MODULE_0__["safeParse"])(jsonPayload);
  } catch (err) {
    return {};
  }
};

/* harmony default export */ __webpack_exports__["default"] = (parseJwt);

/***/ }),

/***/ "./src/pathOr.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _hasOwn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/hasOwn.ts");

/**
 * Returns value at path of given object or provided default value.
 * will return `undefined` if no default is given and path does not resolve
 *
 * @example
 * import pathOr from '@carvana/futilities/pathOr';
 * pathOr({ data: { price: { baselineMin: 5000 } } }, 'data.price.baselineMin', 0)
 * // () => 5000
 */

var pathTo = function pathTo(obj, path, defaultTo) {
  var result = obj;
  var pathArr = path.split('.');

  while (pathArr.length) {
    var nextStep = pathArr.shift();

    if (result && Object(_hasOwn__WEBPACK_IMPORTED_MODULE_0__["default"])(result, nextStep)) {
      result = result[nextStep];
    } else {
      return defaultTo;
    }
  }

  return result;
};

/* harmony default export */ __webpack_exports__["default"] = (pathTo);

/***/ }),

/***/ "./src/roundNumber.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _alwaysNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/alwaysNumber.ts");

/**
 * Rounds a given number to the specified decimal precision.
 *
 * @example
 * import roundNumber from '@carvana/futilities/roundNumber';
 * roundNumber(17.33)
 * // () => 17
 * roundNumber(17.33333, 2)
 * // () => 17.33
 */

function roundNumber(value, precision) {
  if (value === void 0) {
    value = 0;
  }

  if (precision === void 0) {
    precision = 0;
  }

  return Number(Math.round(parseInt(Object(_alwaysNumber__WEBPACK_IMPORTED_MODULE_0__["default"])(value) * 100 + "e" + precision, 10)) + "e-" + precision);
}

/* harmony default export */ __webpack_exports__["default"] = (roundNumber);

/***/ }),

/***/ "./src/safeParse.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable consistent-return */

/**
 * Safely parses a JSON string without throwing
 * (will just return `undefined` if JSON parsing failed)
 *
 * @example
 * import safeParse from '@carvana/futilities/safeParse';
 * safeParse('"{"one":1,"two":2,"three":3}"')
 * // () => {one: 1, two: 2, three: 3}
 * safeParse('')
 * // () => undefined
 * safeParse(42)
 * // () => undefined
 */
function safeParse(inputString) {
  try {
    if (/^({|\[)/.test(inputString)) {
      return JSON.parse(inputString);
    }
  } catch (ex) {
    return null;
  }
}

/* harmony default export */ __webpack_exports__["default"] = (safeParse);

/***/ }),

/***/ "./src/scrollWindowToTop.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/isServerSideRendering.ts");

/**
 * Sends the browser focus to the top (smoothly).
 * Safe to invoke on the server, however it won't do anything.
 */

function scrollWindowToTop() {
  if (!Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

/* harmony default export */ __webpack_exports__["default"] = (scrollWindowToTop);

/***/ }),

/***/ "./src/setCookie.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/isServerSideRendering.ts");

/* eslint-disable consistent-return, no-return-assign */

function _appendToCookies(key, val) {
  if (typeof val === 'undefined') return document.cookie;
  return document.cookie += "; " + key + "=" + val;
}
/**
 * Sets a value for a new or existing cookie (uses `document.cookie`, but safely).
 * Will _not_ set a cookie value to `undefined` or `null`.
 *
 * @example
 * import setCookie from '@carvana/futilities/setCookie';
 * setCookie('latin', null)
 * // () => ''
 * setCookie('lorem', 'ipsum')
 * // () => 'lorem=ipsum'
 * setCookie('dolor', 'sit amet')
 * // () => 'lorem=ipsum; dolor=sit%20amet'
 * setCookie('dolor', 'sit')
 * // () => 'lorem=ipsum; dolor=sit%20amet'
 * setCookie('count', {one: 1, two: 2, three: 3})
 * // () => 'lorem=ipsum; dolor=sit%20amet; count=%7B%22one%22%3A1%2C%22two%22%3A2%2C%22three%22%3A3%7D'
 */


function setCookie(key, val) {
  if (Object(_isServerSideRendering__WEBPACK_IMPORTED_MODULE_0__["default"])()) return;
  var cookieVal = val;

  try {
    if (/^({|\[)/.test(val)) {
      cookieVal = JSON.stringify(val);
    }
  } catch (err) {// Not able to be stringified as JSON, even though the string starts with a square or curly brace
  }

  if (cookieVal != null) {
    cookieVal = encodeURIComponent(cookieVal);
  }

  return _appendToCookies(key, cookieVal);
}

/* harmony default export */ __webpack_exports__["default"] = (setCookie);

/***/ }),

/***/ "./src/usaStates.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
var formatForSelectMenu = states.map(function (state) {
  return {
    value: state,
    display: state
  };
});
var usaStates = {
  asArray: states,
  forSelect: formatForSelectMenu
};
/* harmony default export */ __webpack_exports__["default"] = (usaStates);

/***/ }),

/***/ "./src/userLocation.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromCookies", function() { return fromCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveLocationToCookies", function() { return saveLocationToCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doesUserLocationMatchCookies", function() { return doesUserLocationMatchCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeUserLocation", function() { return makeUserLocation; });
/* harmony import */ var _getCookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/getCookie.ts");
/* harmony import */ var _setCookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/setCookie.ts");


var defaultLocation = {
  city: 'Atlanta',
  state: 'GA',
  zip: '30308'
};
var CITY_COOKIE = 'CVCurrentCity';
var STATE_COOKIE = 'CVCurrentState';
var ZIP_COOKIE = 'CVCurrentZip';
/**
 * Attempts to pull a value (by name) from an object (which can be a server-side
 * cookie store, JSON, or anything else like that), but if it _doesn't_ exist there
 * will fall through to pull it from browser-side cookies.
 */

function fromCookies(cookieName, serverCookies) {
  return serverCookies ? serverCookies[cookieName] : Object(_getCookie__WEBPACK_IMPORTED_MODULE_0__["default"])(cookieName);
}
/**
 * Commits a user location pieces to separate (browser-side) cookies.
 * The names of the browser-side cookies being used will be:
 *  - `CVCurrentCity`
 *  - `CVCurrentState`
 *  - `CVCurrentZip`
 *
 */

function saveLocationToCookies(city, state, zip) {
  Object(_setCookie__WEBPACK_IMPORTED_MODULE_1__["default"])(CITY_COOKIE, city);
  Object(_setCookie__WEBPACK_IMPORTED_MODULE_1__["default"])(STATE_COOKIE, state);
  Object(_setCookie__WEBPACK_IMPORTED_MODULE_1__["default"])(ZIP_COOKIE, zip);
}
/**
 * Checks to see if a `city`, `state` and `zip` field on a given location Object
 * matches the individual cookies (`CVCurrentCity`, `CVCurrentState`, and `CVCurrentZip`)
 * being stored for the current user.
 */

function doesUserLocationMatchCookies(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      city = _ref.city,
      state = _ref.state,
      zip = _ref.zip;

  return city === Object(_getCookie__WEBPACK_IMPORTED_MODULE_0__["default"])(CITY_COOKIE) && state === Object(_getCookie__WEBPACK_IMPORTED_MODULE_0__["default"])(STATE_COOKIE) && "" + zip === "" + Object(_getCookie__WEBPACK_IMPORTED_MODULE_0__["default"])(ZIP_COOKIE);
}
/**
 * Creates a user location Object (which simply contains `city`, `state` and
 * `zip` props) that favors values you pass in, but falls back onto indivial
 * city/state/zip browser-side cookies (`CVCurrentCity`, `CVCurrentState`, and `CVCurrentZip`)
 * if available and finally then to hard-coded values based in Atlanta, GA
 */

function makeUserLocation(existingLocation, serverCookies) {
  return {
    city: existingLocation && existingLocation.city || fromCookies(CITY_COOKIE, serverCookies) || defaultLocation.city,
    state: existingLocation && existingLocation.state || fromCookies(STATE_COOKIE, serverCookies) || defaultLocation.state,
    zip: existingLocation && existingLocation.zip || fromCookies(ZIP_COOKIE, serverCookies) || defaultLocation.zip
  };
}

/***/ })

/******/ });
//# sourceMappingURL=index.js.map